<div class="agpr-account-notes">
    @if (showAddNoteEditor) {
        <div class="agpr-account-notes-card agpr-account-notes-addNote">
            <agpr-textarea-input
                [id]="id + 'addNote.textarea'"
                class="agpr-account-notes-card-textarea"
                [initialFocus]="true"
                ariaLabel="Discover.userNotes.placeholder"
                [placeholder]="'Discover.userNotes.placeholder' | localize"
                [(ngModel)]="noteText"
                [maxLength]="maxLength"
                (blur)="addNote()"
                [bottomMargin]="false"
            ></agpr-textarea-input>
    
            <div class="agpr-account-notes-card-footer">
                <span>{{ !!usersMap[currentUser.id] ? usersMap[currentUser.id] : 'Common.unknownUser' | localize }}</span>
                <span>{{ currentTime | changeTimeZone: timezone : dateFormat }}</span>
            </div>
        </div>
    }

    @if (!_accountNotes?.length && !showAddNoteEditor) {
        <agpr-message
            [severity]="messageSeverity.noContent"
            [useWhiteBg]="true"
        >
            {{ 'Discover.userNotes.noNotesAdded' | localize }}
        </agpr-message>
    } @else {
        <agpr-scroll-panel>
            <ul
                [id]="id + '.noteList'"
                class="agpr-account-notes-card-list"
                [attr.aria-label]="'Discover.userNotes.header' | localize"
                agprListKeyboardNavigation
                [list]="_accountNotes"
            >
                @for (accountNote of _accountNotes; track accountNote.id; let i = $index) {
                    <li
                        [id]="id + '.noteListItem_' + i"
                        class="agpr-account-notes-card agpr-contextMenu-parent"
                    >
                        @if (editingNote === accountNote) {
                            <agpr-textarea-input
                                [id]="id + '.noteListItem.textarea_' + i"
                                class="agpr-account-notes-card-textarea"
                                [initialFocus]="true"
                                ariaLabel="Discover.userNotes.placeholder"
                                [placeholder]="'Discover.userNotes.placeholder' | localize"
                                [(ngModel)]="noteText"
                                [maxLength]="maxLength"
                                (blur)="editNote()"
                            ></agpr-textarea-input>
                            <div class="agpr-account-notes-card-footer">
                                <span>{{ !!usersMap[currentUser.id] ? usersMap[currentUser.id] : 'Common.unknownUser' | localize }}</span>
                                <span>{{ currentTime | changeTimeZone: timezone : dateFormat }}</span>
                            </div>
                        } @else {
                            <pre class="agpr-account-notes-card-content">{{ accountNote.value }}</pre>
                            <div [class]="'agpr-account-notes-card-footer'">
                                <span>{{ usersMap[accountNote.lastUpdatedByUserId] || 'Common.unknownUser' | localize }}</span>
                                <span>{{ accountNote.lastUpdatedDate | changeTimeZone: timezone : dateFormat }}</span>
                            </div>
                            @if (!selfModificationOnly || currentUser.id === accountNote.createdUserId) {
                                <div class="agpr-contextMenu top right">
                                    <agpr-button
                                        [id]="id + '.noteListItem.editButton_' + i"
                                        class="agpr-account-notes-card-contextMenu-button"
                                        [style]="buttonTypes.contextMenu"
                                        icon="fa-regular fa-duotone fa-pen"
                                        tooltip="Discover.userNotes.editNote"
                                        tooltipPosition="top"
                                        (click)="openEditNote(accountNote)"
                                    ></agpr-button>
                                    <agpr-button
                                        [id]="id + '.noteListItem.deleteButton_' + i"
                                        class="agpr-account-notes-card-contextMenu-button"
                                        [style]="buttonTypes.contextMenu"
                                        icon="fa-regular fa-duotone fa-trash-can"
                                        tooltip="Discover.userNotes.deleteNote"
                                        tooltipPosition="top"
                                        (click)="openDeleteNote(accountNote)"
                                    ></agpr-button>
                                </div>
                            }
                        }
                    </li>
                }
            </ul>
        </agpr-scroll-panel>
    }


    <ng-template #actionButtons>
        <agpr-button
            [id]="id + '.addNoteButton'"
            class="agpr-account-notes-addNoteButton"
            [style]="buttonTypes.tertiary"
            [label]="'Discover.userNotes.addNote'"
            (click)="openAddNote()"
        ></agpr-button>
    </ng-template>

</div>
